import React, { useContext } from 'react'
import dynamic from 'next/dynamic'
import { Box } from 'pcln-design-system'
import BootstrapDataContext from '../../context/BootstrapDataContext'

const HomeDesktop = dynamic(() => import('./HomeDesktop'))
const HomeMobile = dynamic(() => import('./HomeMobile'))

export default function Home() {
  const { isMobile = false } = useContext(BootstrapDataContext)

  return <Box>{isMobile ? <HomeMobile /> : <HomeDesktop />}</Box>
}
